// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2-hg1";
export var flexRow = "footer-module--flexRow--30_bl";
export var bold = "footer-module--bold--LTGXm";
export var logo = "footer-module--logo--3sxBO";
export var companyAddress = "footer-module--companyAddress--Arh5f";
export var siteInfo = "footer-module--siteInfo--3Hu-4 typography-module--responsiveMicroSmall--3ULs6";
export var textRight = "footer-module--textRight--bmuDs";
export var leftArea = "footer-module--leftArea--32vIu";